import { render, staticRenderFns } from "./awardDialog.vue?vue&type=template&id=0158a9e9&scoped=true&"
import script from "./awardDialog.vue?vue&type=script&lang=js&"
export * from "./awardDialog.vue?vue&type=script&lang=js&"
import style0 from "./awardDialog.vue?vue&type=style&index=0&id=0158a9e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0158a9e9",
  null
  
)

export default component.exports